<template>
    <Teleport to=".frame-common">
        <div class="modal" :class="class" :id="id" aria-hidden="true" @click="clickedOnBackgroundEvent" ref="background">
            <div class="modal__content">
                <div class="modal__content__header">
                    <slot name="header">
                        <div class="modal__content__header__title">
                            <slot name="header-title"></slot>
                        </div>
                        <div class="modal__content__header__cancel">
                            <slot name="header-cancel">
                                <div @click="cancelModalEvent">×</div>
                            </slot>
                        </div>
                    </slot>
                </div>
                <div class="modal__content__body">
                    <slot name="body"></slot>
                </div>
                <div class="modal__content__footer">
                    <slot name="footer">
                        <div v-if="displayDefaultCancelButton" class="modal__content__footer__cancel">
                            <slot name="footer-cancel">
                                <Button @click="cancelModalEvent">{{ $t('labels.cancel') }}</Button>
                            </slot>
                        </div>
                        <div class="modal__content__footer__other">
                            <slot name="footer-other"></slot>
                        </div>
                    </slot>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script>
import Button from "primevue/button";

export default {
    components: {Button},

    props: {
        backgroundClickEvent: {
            required: false,
            type: [Function, Boolean],
            default: true
        },

        displayDefaultCancelButton: {
            required: false,
            type: Boolean,
            default: true
        },

        class: {
            required: false,
            default: null
        },

        id: {
            required: false,
            default: null
        }
    },

    emits: ['modal:cancel'],

    methods: {
        cancelModalEvent() {
            this.$emit('modal:cancel');
        },

        clickedOnBackgroundEvent($event) {
            if($event.target !== this.$refs.background) {
                return;
            }

            switch(typeof this.backgroundClickEvent) {
                case 'boolean':
                    if(this.backgroundClickEvent) {
                        this.cancelModalEvent();
                    }
                    break;
                case 'function':
                    this.backgroundClickEvent($event, this);
                    break;
            }
        }
    }
}
</script>

<style lang="scss">
.modal {
    width: 100%;
    background-color: color-mix(in oklab, var(--color-black) 80%, transparent);
    height: 100vh;
    position: fixed;

    &__content {
        position: absolute;
        background-color: var(--color-silver);
        padding: var(--padding-thick);
        width: clamp(300px, 100%, 900px);
        transform: translate(-50%, -50%);
        top: 50%;
        left: 50%;

        &__header {
            display: grid;
            grid-template-columns: 1fr auto;
            align-items: center;

            &__cancel {
                font-size: 150%;
                cursor: pointer;
            }
        }

        &__body {
            margin: {
                top: var(--margin);
                bottom: var(--margin);
            }
        }

        &__footer {
            display: flex;
            gap: var(--gap);
            flex-direction: row-reverse;

            &__other {
                display: flex;
                gap: var(--gap);
            }
        }
    }
}
</style>
